import React, { Component } from 'react';
import styles from './_screen.module.scss';

class Screen extends Component {
  render() {
    const { children, class: className } = this.props;

    return (
      <div className={`${styles['screen']} ${className || ''}`}>
        <div>{children}</div>
      </div>
    );
  }
}

export default Screen;
